
(function () {

    /* =========================================================
       PRODUCT DETECTION
    ========================================================= */

    const path = window.location.pathname.toLowerCase();

    if (!path.includes("/products/pure-stallion-v2")) return;


    document.addEventListener("DOMContentLoaded", function () {

        const freebiesWrapper =
            document.querySelector(".freebies-wrapper");

        if (!freebiesWrapper) return;


        const LOCK_SRC =
            "https://cdn.shopify.com/s/files/1/0867/9673/0684/files/locked_image-Gray.png?v=1775545017";


        /* =========================================================
           GET FREEBIE ITEMS
        ========================================================= */

        function getItem(n) {

            const item =
                document.querySelector(
                    `.freebies-wrapper > .item:nth-child(${n})`
                );

            if (!item) return null;


            const img =
                item.querySelector("img");

            const title =
                item.querySelector(".item-title");

            const tag =
                item.querySelector(".tag");


            /*
             * Save ORIGINAL values only once.
             */

            if (img && !img.dataset.original) {
                img.dataset.original = img.src;
            }

            if (title && !title.dataset.original) {
                title.dataset.original = title.innerHTML;
            }

            if (tag && !tag.dataset.original) {
                tag.dataset.original = tag.innerHTML;
            }


            return {
                img: img,
                title: title,
                tag: tag
            };
        }


        /* =========================================================
           GET ALL FREEBIES
        ========================================================= */

        function getItems() {

            return {
                item1: getItem(1),
                item2: getItem(2),
                item3: getItem(3),
                item4: getItem(4)
            };

        }


        /* =========================================================
           MARKET / CURRENCY VALUES
        ========================================================= */

        function getBonusValues() {

            const currency =
                window.Shopify?.currency?.active || "AUD";


            const values = {

                AUD: {
                    total: "$189.75",
                    shred: "$79.95"
                },

                USD: {
                    total: "$124.95",
                    shred: "$52.95"
                },

                GBP: {
                    total: "£81.80",
                    shred: "£38.50"
                },

                AED: {
                    total: "AED 459",
                    shred: "AED 193"
                }

            };


            return values[currency] || values.AUD;

        }


        /* =========================================================
           LOCK
        ========================================================= */

        function lock(item, text = "3+ Bottles") {

            if (!item) return;


            if (item.img) {

                if (!item.img.dataset.original) {
                    item.img.dataset.original =
                        item.img.src;
                }

                item.img.src = LOCK_SRC;
            }


            if (item.title) {

                item.title.innerHTML =
                    `Unlock<br>${text}`;

            }


            if (item.tag) {

                item.tag.innerHTML =
                    `Unlock<br>${text}`;

            }

        }


        /* =========================================================
           UNLOCK
        ========================================================= */

        function unlock(item) {

            if (!item) return;


            if (
                item.img &&
                item.img.dataset.original
            ) {

                item.img.src =
                    item.img.dataset.original;

            }


            if (
                item.title &&
                item.title.dataset.original
            ) {

                item.title.innerHTML =
                    item.title.dataset.original;

            }


            if (
                item.tag &&
                item.tag.dataset.original
            ) {

                item.tag.innerHTML =
                    item.tag.dataset.original;

            }

        }


        /* =========================================================
           BONUS TEXT
        ========================================================= */

        function updateBonus(type) {

            const el =
                document.querySelector(
                    ".bundleBonusText"
                );

            if (!el) return;


            const bonus =
                getBonusValues();


            /* =====================================================
               3 BOTTLES
            ===================================================== */

            if (type === "all") {

                el.innerHTML =
                    `<strong>All bonuses unlocked</strong><br>` +
                    `you're getting ` +
                    `<b>${bonus.total} in free gifts</b>`;

            }


            /* =====================================================
               2 BOTTLES
            ===================================================== */

            if (type === "mid") {

                el.innerHTML =
                    `Upgrade to <b>3 bottles</b> to unlock your ` +
                    `<b>FREE Shred Cut ` +
                    `(${bonus.shred} value)</b>`;

            }


            /* =====================================================
               1 BOTTLE
            ===================================================== */

            if (type === "low") {

                el.innerHTML =
                    `You're <b>1 bottle away</b> from unlocking ` +
                    `<b>${bonus.total} in free bonuses</b>`;

            }

        }


        /* =========================================================
           FREE SHIPPING
        ========================================================= */

        function updateShipping(type) {

            const shippingEl =
                document.querySelector(
                    ".freeShippingText"
                );

            if (!shippingEl) return;


            if (type === "free") {

                shippingEl.innerHTML =
                    "<strong>FREE SHIPPING</strong>";

                shippingEl.classList.add(
                    "unlocked"
                );

                shippingEl.classList.remove(
                    "locked"
                );

            } else {

                shippingEl.innerHTML =
                    "FREE SHIPPING";

                shippingEl.classList.remove(
                    "unlocked"
                );

                shippingEl.classList.add(
                    "locked"
                );

            }

        }


        /* =========================================================
           APPLY BUNDLE
        ========================================================= */

        function apply(bundleNumber) {

            const {
                item1,
                item2,
                item3,
                item4
            } = getItems();


            if (!item1 || !item2 || !item3 || !item4) {
                return;
            }


            /* =====================================================
               3 BOTTLES
               
               ALL GIFTS UNLOCKED
               FREE SHIPPING UNLOCKED
            ===================================================== */

            if (bundleNumber === 1) {

                unlock(item1);
                unlock(item2);
                unlock(item3);
                unlock(item4);

                updateBonus("all");

                updateShipping("free");

                return;
            }


            /* =====================================================
               2 BOTTLES
               
               GIFT 1 LOCKED
               FREE SHIPPING UNLOCKED
            ===================================================== */

            if (bundleNumber === 2) {

                lock(
                    item1,
                    "3+ Bottles"
                );

                unlock(item2);
                unlock(item3);
                unlock(item4);

                updateBonus("mid");

                updateShipping("free");

                return;
            }


            /* =====================================================
               1 BOTTLE
               
               GIFTS 1 + 2 LOCKED
               FREE SHIPPING LOCKED
            ===================================================== */

            if (bundleNumber === 3) {

                lock(
                    item1,
                    "3+ Bottles"
                );

                lock(
                    item2,
                    "2+ Bottles"
                );
                lock(
                    item3,
                    "2+ Bottles"
                );

                unlock(item4);

                updateBonus("low");

                /*
                 * Bundle 3 = NO FREE SHIPPING
                 */
                updateShipping("locked");

                return;
            }

        }


        /* =========================================================
           FIND CURRENT BUNDLE
        ========================================================= */

        function getCurrentBundle() {

            const selected =
                document.querySelector(
                    'input[name="cb"]:checked'
                );


            if (selected) {

                const value =
                    parseInt(selected.value, 10);

                if (
                    value === 1 ||
                    value === 2 ||
                    value === 3
                ) {
                    return value;
                }

            }


            const bundle1 =
                document.querySelector(
                    "#pumper__label_1"
                );

            const bundle2 =
                document.querySelector(
                    "#pumper__label_2"
                );

            const bundle3 =
                document.querySelector(
                    "#pumper__label_3"
                );


            if (
                bundle1 &&
                (
                    bundle1.classList.contains("active") ||
                    bundle1.classList.contains("selected") ||
                    bundle1.closest(
                        ".pumper_horizontal_card--selected"
                    ) ||
                    bundle1.querySelector(
                        "input:checked"
                    )
                )
            ) {
                return 1;
            }


            if (
                bundle2 &&
                (
                    bundle2.classList.contains("active") ||
                    bundle2.classList.contains("selected") ||
                    bundle2.closest(
                        ".pumper_horizontal_card--selected"
                    ) ||
                    bundle2.querySelector(
                        "input:checked"
                    )
                )
            ) {
                return 2;
            }


            if (
                bundle3 &&
                (
                    bundle3.classList.contains("active") ||
                    bundle3.classList.contains("selected") ||
                    bundle3.closest(
                        ".pumper_horizontal_card--selected"
                    ) ||
                    bundle3.querySelector(
                        "input:checked"
                    )
                )
            ) {
                return 3;
            }


            return null;

        }


        /* =========================================================
           BUNDLE CLICK EVENT
        ========================================================= */

        document.addEventListener(
            "click",
            function (event) {

                let bundleNumber = null;


                if (
                    event.target.closest(
                        "#pumper__label_1"
                    )
                ) {

                    bundleNumber = 1;

                } else if (
                    event.target.closest(
                        "#pumper__label_2"
                    )
                ) {

                    bundleNumber = 2;

                } else if (
                    event.target.closest(
                        "#pumper__label_3"
                    )
                ) {

                    bundleNumber = 3;

                }


                if (!bundleNumber) return;


                /*
                 * Apply after Pumper updates.
                 */

                setTimeout(function () {

                    apply(bundleNumber);

                }, 100);


                setTimeout(function () {

                    apply(bundleNumber);

                }, 300);


                setTimeout(function () {

                    apply(bundleNumber);

                }, 700);

            }
        );


        /* =========================================================
           INITIALIZE
        ========================================================= */

        let initializationAttempts = 0;

        const initializationInterval =
            setInterval(function () {

                initializationAttempts++;


                const bundle1 =
                    document.querySelector(
                        "#pumper__label_1"
                    );

                const bundle2 =
                    document.querySelector(
                        "#pumper__label_2"
                    );

                const bundle3 =
                    document.querySelector(
                        "#pumper__label_3"
                    );


                if (
                    bundle1 ||
                    bundle2 ||
                    bundle3
                ) {

                    clearInterval(
                        initializationInterval
                    );


                    /*
                     * PSV2 default = Bundle 1
                     * ALL GIFTS + FREE SHIPPING
                     */

                    apply(1);


                    setTimeout(function () {
                        apply(1);
                    }, 300);


                    setTimeout(function () {
                        apply(1);
                    }, 800);

                }


                if (
                    initializationAttempts >= 150
                ) {

                    clearInterval(
                        initializationInterval
                    );

                }

            }, 100);


        /* =========================================================
           WATCH FREEBIES FOR DYNAMIC CHANGES
        ========================================================= */

        const observer =
            new MutationObserver(function () {

                const currentBundle =
                    getCurrentBundle();


                if (currentBundle) {

                    setTimeout(function () {

                        apply(currentBundle);

                    }, 50);

                }

            });


        observer.observe(
            freebiesWrapper,
            {
                childList: true,
                subtree: true
            }
        );

    });

})();

